import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-900 px-4 py-10 sm:px-6" data-id="element-182" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-183" data-mp="206rj9imgluta">
        <p className="font-display text-lg font-bold uppercase tracking-wide text-white sm:text-xl" data-id="element-184" data-mp="2f4jtbv98lr03">
          Oclusion Clinical Playbook™
        </p>
        <p className="mt-2 text-[14px] leading-relaxed text-slate-400" data-id="element-185" data-mp="2a69y5kniiqeh">
          Organize your reasoning. Structure your decisions. Build a more consistent clinical
          workflow.
        </p>
        <p className="mt-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-gold-500" data-id="element-186" data-mp="1himj0l50grz8">
          Created by Dr. Karito
        </p>

        <div className="gold-rule mx-auto my-6 h-px w-24" data-id="element-187" data-mp="1rf8z6wme6uux" />

        <p className="text-[12px] leading-relaxed text-slate-500" data-id="element-188" data-mp="1rdxy54kc017i">
          Educational material only. This product does not provide diagnosis or treatment
          recommendations and does not replace professional clinical judgment. Application of any
          educational material should be adapted to the individual patient and the responsible
          clinician’s professional judgment.
        </p>
        <p className="mt-4 text-[12px] text-slate-500" data-id="element-189" data-mp="1ihujjpycu5n7">
          © 2026 Dr. Karito. All rights reserved.
        </p>
      </div>
    </footer>;
}